/* ============================================================
   ORA — Tiroir panier
   ============================================================ */

(function () {
  'use strict';

  // ── Config ──────────────────────────────────────────────
  var THRESHOLD = window.oraCartConfig ? window.oraCartConfig.threshold : 4000;
  var upsellProduct = window.oraUpsellProduct || null;
  var selectedVariantId = null;
  var upsellInProgress = false;

  // ── Éléments DOM ─────────────────────────────────────────
  var overlay       = document.getElementById('ora-cd-overlay');
  var drawer        = document.getElementById('ora-cd');
  var closeBtn      = document.getElementById('ora-cd-close');
  var body          = document.getElementById('ora-cd-body');
  var footer        = document.getElementById('ora-cd-footer');
  var barFill       = document.getElementById('ora-cd-bar-fill');
  var shipMsg       = document.getElementById('ora-cd-ship-msg');
  var subtotalEl    = document.getElementById('ora-cd-subtotal');
  var upsellWrap    = document.getElementById('ora-cd-upsell');
  var upsellVars    = document.getElementById('ora-cd-upsell-variants');
  var upsellBtn     = document.getElementById('ora-cd-upsell-btn');
  var upsellPriceEl = document.getElementById('ora-cd-upsell-price');
  var upsellLabelEl = document.getElementById('ora-cd-upsell-label');

  if (!drawer) return;

  // ── Ouvrir / Fermer ──────────────────────────────────────
  function open() {
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    loadCart();
  }

  function close() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('a[href="/cart"], .ora-header__cart-link, [data-open-cart]');
    if (!trigger) return;
    e.preventDefault();
    open();
  });

  // ── Charger le panier ─────────────────────────────────────
  function loadCart() {
    body.classList.add('is-loading');
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
        body.classList.remove('is-loading');
      })
      .catch(function () { body.classList.remove('is-loading'); });
  }

  // ── Formater le prix ─────────────────────────────────────
  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '—';
    return (cents / 100).toLocaleString('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    });
  }

  // ── Barre de progression — délégué au snippet ora-shipping-bar ──
  function updateShippingBar(totalCents) {
    if (typeof totalCents !== 'number' || isNaN(totalCents)) return;
    document.dispatchEvent(new CustomEvent('ora:cart:updated', { detail: { total_price: totalCents } }));
  }

  // ── Compteur header ───────────────────────────────────────
  function updateHeaderCount(count) {
    document.querySelectorAll('.ora-header__cart-count').forEach(function (el) {
      el.textContent = count > 0 ? '(' + count + ')' : '';
    });
  }

  // ── Bloc upsell ───────────────────────────────────────────
  function renderUpsell() {
    if (!upsellProduct || !upsellWrap) return;

    upsellWrap.style.display = 'block';
    if (upsellLabelEl) upsellLabelEl.textContent = upsellProduct.label;

    var firstAvailable = upsellProduct.variants.find(function (v) { return v.available; });
    selectedVariantId = firstAvailable
      ? firstAvailable.id
      : (upsellProduct.variants[0] ? upsellProduct.variants[0].id : null);

    if (upsellPriceEl && firstAvailable) {
      upsellPriceEl.textContent = formatMoney(firstAvailable.price);
    }

    var variants = upsellProduct.variants;
    var isSingleDefault = variants.length === 1 && variants[0].title === 'Default Title';

    if (!isSingleDefault) {
      var html = '';
      variants.forEach(function (v) {
        var isSelected = v.id === selectedVariantId;
        html += '<button class="ora-cd__upsell-var' + (isSelected ? ' is-selected' : '') + '"'
          + ' data-variant-id="' + v.id + '"'
          + ' data-price="' + v.price + '"'
          + (v.available ? '' : ' disabled')
          + '>' + v.title + '</button>';
      });
      upsellVars.innerHTML = html;
      upsellVars.style.display = 'flex';
    } else {
      upsellVars.style.display = 'none';
    }

    updateUpsellBtn();
  }

  function updateUpsellBtn() {
    if (!upsellBtn) return;
    if (upsellInProgress) return; // ne pas écraser l'état en cours
    var variant = upsellProduct && upsellProduct.variants.find(function (v) {
      return v.id === selectedVariantId;
    });
    var available = variant ? variant.available : false;
    upsellBtn.disabled = !available || !selectedVariantId;
  }

  // Clic sur une variante upsell
  if (upsellVars) {
    upsellVars.addEventListener('click', function (e) {
      var btn = e.target.closest('.ora-cd__upsell-var');
      if (!btn || btn.disabled) return;

      upsellVars.querySelectorAll('.ora-cd__upsell-var').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
      selectedVariantId = parseInt(btn.dataset.variantId, 10);

      if (upsellPriceEl) {
        upsellPriceEl.textContent = formatMoney(parseInt(btn.dataset.price, 10));
      }
      updateUpsellBtn();
    });
  }

  // Clic sur le bouton "Ajouter au panier"
  if (upsellBtn) {
    upsellBtn.addEventListener('click', function () {
      if (!selectedVariantId || upsellBtn.disabled || upsellInProgress) return;

      upsellInProgress = true;
      upsellBtn.disabled = true;
      upsellBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function () {
        upsellBtn.classList.remove('is-loading');
        upsellBtn.classList.add('is-added');
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          });
      })
      .then(function (cart) {
        if (typeof cart.total_price !== 'number') throw new Error('Invalid cart');
        updateShippingBar(cart.total_price);
        updateHeaderCount(cart.item_count);
        subtotalEl.textContent = formatMoney(cart.total_price);
        renderCart(cart);
        setTimeout(function () {
          upsellBtn.classList.remove('is-added');
          upsellBtn.disabled = false;
          upsellInProgress = false;
        }, 1500);
      })
      .catch(function () {
        upsellBtn.classList.remove('is-loading');
        upsellBtn.disabled = false;
        upsellInProgress = false;
        loadCart(); // fallback : recharge le panier complet
      });
    });
  }

  // ── Rendu du panier ───────────────────────────────────────
  function renderCart(cart) {
    if (!cart || typeof cart.total_price !== 'number') {
      loadCart();
      return;
    }

    updateShippingBar(cart.total_price);
    updateHeaderCount(cart.item_count);
    subtotalEl.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) {
      body.innerHTML = [
        '<div class="ora-cd__empty" style="display:flex;">',
        '  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">',
        '    <path d="M5 8h14l-1.2 12.2a1 1 0 0 1-1 .9H7.2a1 1 0 0 1-1-.9L5 8Z"/>',
        '    <path d="M9 8V6a3 3 0 1 1 6 0v2"/>',
        '  </svg>',
        '  <p>Ton panier est vide</p>',
        '</div>'
      ].join('');
      footer.style.display = 'none';
      return;
    }

    footer.style.display = '';
    renderUpsell();

    var html = '';
    cart.items.forEach(function (item, index) {
      var lineNumber = index + 1; // 1-based line index (stable pour /cart/change.js)
      var imgTag = item.image
        ? '<img class="ora-cd__item-img" src="' + item.image + '" alt="' + item.product_title + '" loading="lazy">'
        : '<div class="ora-cd__item-img-placeholder"></div>';

      var variantInfo = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="ora-cd__item-variant">' + item.variant_title + '</p>'
        : '';

      html += [
        '<div class="ora-cd__item" data-line="' + lineNumber + '">',
        '  <a href="' + item.url + '">' + imgTag + '</a>',
        '  <div class="ora-cd__item-info">',
        '    <div>',
        '      <p class="ora-cd__item-name">' + item.product_title + '</p>',
        '      ' + variantInfo,
        '    </div>',
        '    <div class="ora-cd__item-bottom">',
        '      <div class="ora-cd__qty">',
        '        <button class="ora-cd__qty-btn" data-line="' + lineNumber + '" data-qty="' + (item.quantity - 1) + '" aria-label="Diminuer">−</button>',
        '        <span class="ora-cd__qty-val">' + item.quantity + '</span>',
        '        <button class="ora-cd__qty-btn" data-line="' + lineNumber + '" data-qty="' + (item.quantity + 1) + '" aria-label="Augmenter">+</button>',
        '      </div>',
        '      <div style="display:flex;align-items:center;gap:8px;">',
        '        <span class="ora-cd__item-price">' + formatMoney(item.final_line_price) + '</span>',
        '        <button class="ora-cd__item-remove" data-line="' + lineNumber + '" aria-label="Supprimer">',
        '          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
        '        </button>',
        '      </div>',
        '    </div>',
        '  </div>',
        '</div>'
      ].join('');
    });

    body.innerHTML = html;
  }

  // ── Toast stock épuisé ────────────────────────────────────
  function showStockToast() {
    var existing = document.getElementById('ora-cd-toast');
    if (existing) { existing.remove(); }
    var toast = document.createElement('div');
    toast.id = 'ora-cd-toast';
    toast.textContent = 'Stock insuffisant pour cette quantité.';
    toast.style.cssText = [
      'position:absolute;bottom:80px;left:50%;transform:translateX(-50%)',
      'background:#2E2B26;color:#FBF8F2;font-family:Manrope,sans-serif',
      'font-size:12px;font-weight:500;padding:10px 18px',
      'white-space:nowrap;z-index:500;pointer-events:none',
      'animation:ora-toast-in .2s ease'
    ].join(';');
    drawer.appendChild(toast);
    setTimeout(function () { if (toast.parentNode) toast.remove(); }, 2800);
  }

  // ── Modifier quantité (utilise le line index, plus fiable que la key) ────
  function changeQty(line, qty, btn) {
    if (btn) { btn.disabled = true; }
    body.classList.add('is-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function (r) {
      if (r.status === 422) {
        body.classList.remove('is-loading');
        if (btn) { btn.disabled = false; }
        showStockToast();
        return null; // stop la chaîne
      }
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function (cart) {
      if (!cart) return; // arrêt propre après 422
      if (typeof cart.total_price !== 'number') throw new Error('Invalid cart');
      renderCart(cart);
      body.classList.remove('is-loading');
    })
    .catch(function () {
      body.classList.remove('is-loading');
      if (btn) { btn.disabled = false; }
      loadCart(); // fallback propre
    });
  }

  // ── Délégation d'événements ───────────────────────────────
  body.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.ora-cd__qty-btn');
    if (qtyBtn) {
      if (qtyBtn.disabled) return;
      var line = parseInt(qtyBtn.dataset.line, 10);
      var qty  = Math.max(0, parseInt(qtyBtn.dataset.qty, 10));
      if (!isNaN(line) && line > 0) changeQty(line, qty, qtyBtn);
      return;
    }
    var removeBtn = e.target.closest('.ora-cd__item-remove');
    if (removeBtn) {
      if (removeBtn.disabled) return;
      var rline = parseInt(removeBtn.dataset.line, 10);
      if (!isNaN(rline) && rline > 0) changeQty(rline, 0, removeBtn);
    }
  });

  // ── Événements globaux ────────────────────────────────────
  document.addEventListener('ora:cart:open', open);
  document.addEventListener('ora:cart:refresh', loadCart);

})();
